export default [
    {
      path: "/pdpa/list",
      name: "pdpa-list",
      component: () => import("@/views/pages/pdpa/pdpa-list/PdpaList.vue"),
      meta: {
  
      },
    },
  ];
  